module.exports = __webpack_public_path__ + "img/logoc1.ecb080b9.svg";